
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/reviewers",
      function () {
        return require("private-next-pages/info/reviewers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/reviewers"])
      });
    }
  